import { render, staticRenderFns } from "./CulturePromotionFormType.vue?vue&type=template&id=2840f49d&scoped=true&"
import script from "./CulturePromotionFormType.vue?vue&type=script&lang=js&"
export * from "./CulturePromotionFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840f49d",
  null
  
)

export default component.exports